import React from 'react'
import TemplatizedTextField, {
    TemplatizedTextFieldProps,
} from '@pushly/aqe/lib/components/templatized-text-field/templatized-text-field'

type TemplateLandingUrlFieldProps = TemplatizedTextFieldProps

const TemplateLandingUrlField = (props: TemplateLandingUrlFieldProps) => {
    return (
        <TemplatizedTextField
            label="Landing URL"
            placeholder="https://my.landing-page.domain/my-article"
            {...props}
            hideEmojis={true}
            autoComplete="off"
        />
    )
}

export default TemplateLandingUrlField
